import { Column, Columns } from '@vtex/admin-ui'
import {
  Accumulate,
  AccumulateManualPrices,
  Accumulations,
  AdditionalInformation,
  BIN,
  Budget,
  Cluster,
  Conditions,
  MaxItemsPerAttribute,
  MaxItemsPerCart,
  MaxUsage,
  MaxUsagePerClient,
  OrderValue,
  Origin,
  PaymentMethods,
  PromotionHighlight,
  Restrictions,
  SalesChannels,
  Sellers,
  Storefront,
  UTM,
} from 'ui'
import { GeneralInformation } from '../../GeneralInformation'
import { StackedBoxes } from '../../StackedBoxes'
import { BuyTogetherEffect } from './BuyTogetherEffect'

export default function BuyTogetherForm() {
  return (
    <Columns space="$space-20">
      <Column units={7}>
        <GeneralInformation />
        <BuyTogetherEffect name="buyTogether" />
        <Conditions>
          <OrderValue name="conditions.orderValue" />
          <PaymentMethods name="conditions.paymentMethods" />
          <BIN name="conditions.bin" />
          <Cluster name="conditions.cluster" />
          <UTM name="conditions.utm" />
        </Conditions>
        <Restrictions>
          <MaxUsage name="restrictions.maxUsage" />
          <MaxUsagePerClient name="restrictions.maxUsagePerClient" />
        </Restrictions>
        <Accumulations>
          <Accumulate name="restrictions.accumulate" />
          <AccumulateManualPrices name="restrictions.accumulateWithManualPrices" />
        </Accumulations>
        <Storefront>
          <PromotionHighlight name="storefront.highlight" />
          <AdditionalInformation name="storefront.additionalInformation" />
        </Storefront>
      </Column>
      <Column>
        <StackedBoxes>
          <Origin name="restrictions.origin" />
          <SalesChannels name="restrictions.salesChannels" />
          <Budget name="restrictions.budget" />
          <Sellers name="restrictions.sellers" />
        </StackedBoxes>
      </Column>
    </Columns>
  )
}
